import React from "react";
import "./textEffect.css";

interface TextEffectProps {
  text: string;
}

const TextEffectBottomLeft: React.FC<TextEffectProps> = ({ text }) => {
  return (
    <div className="container">
      <div className="text-effect" data-text={text}>       
        <span className="clone clone-6" data-text={text}>{text}</span>
        <span className="clone clone-7" data-text={text}>{text}</span>
        <span className="clone clone-8" data-text={text}>{text}</span>
        <span className="clone clone-9" data-text={text}>{text}</span>
        <span className="clone clone-10" data-text={text}>{text}</span>
        <span className="main-text">{text}</span>
      </div>
    </div>
  );
};

export default TextEffectBottomLeft;